<mibi-wall-of-text-layout wotTitle="Datenschutzerklärung">
    <ng-container mibi-wot-preamble>
        Für das Bundesinstitut für Risikobewertung (BfR) ist ein
        verantwortungsbewusster Umgang mit personenbezogenen Daten ein wichtiges
        Anliegen. Wir möchten, dass Nutzerinnen und Nutzer wissen, wann welche
        Daten durch das BfR erhoben und verwendet werden. Das BfR betreibt unter
        der Domain
        <a href="https://mibi-portal.bfr.bund.de/" target="_blank"
            >mibi-portal.bfr.bund.de</a
        >
        ein Web-Portal zum Austausch von Probendaten, die an die NRLs des BfR
        gesendet werden.Personenbezogene Daten werden von uns nur im notwendigen
        Umfang verarbeitet. Welche Daten auf welcher Grundlage verarbeitet
        werden, ist abhängig davon, für welchen Zweck diese benötigt werden.
    </ng-container>
    <mibi-datenschutzerklaerung mibi-wot-content [model]="datenschutzerklaerungViewModel"></mibi-datenschutzerklaerung>
</mibi-wall-of-text-layout>
